<template>
	<v-container>
		<p>
			The variable is scored on a scale from 0 to 100, with 100 representing the highest level of environmental performance. This map represents these scores, highlighting the 	Environmental Performance Index (EPI) of 180 countries, combining data on 58 performance indicators, focusing on climate change performance, environmental health, and ecosystem vitality. 
		</p>
		<p style="font-weight: bold;">Source: Yale Center for Environmental Law and Policy.</p>
		<v-card>
			<iframe
				title="Human Rights in the World"
				aria-label="Map"
				id="datawrapper-chart-6M3Wv"
				src="https://datawrapper.dwcdn.net/6M3Wv/1/"
				scrolling="no"
				frameborder="0"
				style="width: 0; min-width: 100% !important; border: none;"
				height="441"
				data-external="1"
			>
			</iframe>
		</v-card>
	</v-container>
</template>

<script>
export default {
	mounted() {
		// Function to dynamically load external script
		const loadScript = (src, callback) => {
			const script = document.createElement("script")
			script.src = src
			script.onload = callback
			document.head.appendChild(script)
		}

		// Load the Datawrapper events script
		loadScript("https://static.dwcdn.net/js/events.js", () => {
			// Ensure the `datawrapper` object is available
			if (window.datawrapper) {
				window.datawrapper.on("region.click", (event) => {
					console.log(event.chartId, event.data)
				})
			}
		})

		// Handle iframe resizing
		const iframe = document.getElementById("datawrapper-chart-6M3Wv")
		iframe.onload = () => {
			window.addEventListener("message", (event) => {
				if (event.data && event.data["datawrapper-height"]) {
					const iframes = document.querySelectorAll("iframe")
					for (const key in event.data["datawrapper-height"]) {
						for (let i = 0; i < iframes.length; i++) {
							if (iframes[i].contentWindow === event.source) {
								iframes[i].style.height =
									event.data["datawrapper-height"][key] + "px"
							}
						}
					}
				}
			})
		}
	},
}
</script>

<style scoped>
/* Add any custom styles here */
</style>
